"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSocialIcons = require("react-social-icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SocialIcons = function SocialIcons(_ref) {
  var socials = _ref.socials;
  return Array.isArray(socials) && socials.length > 0 ? socials.map(function (sm) {
    return /*#__PURE__*/_react["default"].createElement(_reactSocialIcons.SocialIcon, {
      url: sm,
      key: sm,
      rel: "noreferrer noopener",
      target: "_blank",
      style: {
        margin: '0.25rem'
      }
    });
  }) : null;
};

SocialIcons.defaultProps = {
  socials: []
};
SocialIcons.propTypes = {
  socials: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired
};
var _default = SocialIcons;
exports["default"] = _default;